import type { FC } from "react";

import { Skeleton } from "@/components/ui/skeleton";

/** Stands in while the contract's contacts load — three rows of the same
 * height as the real ones, so the card doesn't resize when they land. */
const OccupantsTableSkeleton: FC = () => (
  <div className="flex flex-col">
    {[0, 1, 2].map((row) => (
      <div key={row} className="flex items-center gap-4 border-b px-4 py-3">
        <Skeleton className="h-5 w-[228px]" />
        <Skeleton className="h-5 flex-1" />
        <Skeleton className="h-5 w-[208px]" />
        <Skeleton className="h-5 w-[96px]" />
      </div>
    ))}
  </div>
);

export default OccupantsTableSkeleton;
